import Navigation from '@/components/Navigation';
import HeroSection from '@/components/HeroSection';
import Footer from '@/components/Footer';
import PageSEO from '@/components/PageSEO';
import MaintenancePage from './Maintenance';
import { useSiteSettings } from '@/hooks/useSiteSettings';
import { useAuth } from '@/hooks/useAuth';

const Index = () => {
  const { settings, loading } = useSiteSettings();
  const { isAdmin } = useAuth();

  if (!loading && settings.maintenance_mode && !isAdmin) {
    return <MaintenancePage />;
  }

  return (
    <main className="min-h-screen flex flex-col bg-background">
      <PageSEO path="/" />
      <Navigation />
      <HeroSection />
      <Footer />
    </main>
  );
};

export default Index;
